import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of, tap } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { HttpService } from "../http.service";
import { CancelRecord } from "../../../models/admin/orders.model";
import { AdminOrderAddressInput, bulkOrderInput, cancelInput, OrderListResponse, OrderResponse, orderStatusInput, shippingOrderInput, SubmitResponse } from "@sgm-frontend/core";


@Injectable({
    providedIn: 'root'
})
export class OrdersService extends HttpService<any | cancelInput, OrderListResponse> {

    private orderListSubject = new BehaviorSubject<OrderListResponse | null>(null);
    readonly orderList$ = this.orderListSubject.asObservable();
    constructor(
        httpClient: HttpClient,
        @Inject('API_URL') apiUrl: string,
        @Inject('API_VERSION') apiVersion: string
    ) {
        super(httpClient, apiUrl, apiVersion, 'orders');
    }


    getAllOrders(page = 1, limit = 10): Observable<OrderListResponse | null> {
        return this.getPagedGeneral('orders', page, limit).pipe(
            tap(response => this.orderListSubject.next(response)),
            catchError(() => of(null))
        );
    }
    getFilteredOrders(entity: any): Observable<OrderListResponse | null> {
        return this.filterAllActionPaged(entity, '').pipe(
            tap((response) => this.orderListSubject.next(response)),
            catchError(() => of(null))
        );
    }
    getCancelOrderByOrderId(orderId: string): Observable<CancelRecord> {
        return this.getById(orderId, 'cancel').pipe(catchError((error) => of(error)));
    }
    updateCancelOrderStatus(cancelInput: cancelInput): Observable<CancelRecord> {
        return this.update(cancelInput, 'cancel').pipe(catchError((error) => of(error)));
    }
    getOrderByOrderId(orderId: string): Observable<OrderResponse> {
        return this.getById(orderId + "/admin").pipe(catchError((error) => of(error)));
    }
    getOrderByOrderIdAdmin(orderId: string): Observable<OrderResponse> {
        return this.getById(orderId + "/admin").pipe(catchError((error) => of(error)));
    }
    deleteOrderByOrderId(orderId: string): Observable<SubmitResponse> {
        return this.delete(orderId);
    }

    createManualOrder(OrderInput: any): Observable<CancelRecord> {
        return this.create(OrderInput, 'guest').pipe(catchError((error) => of(error)));
    }
    updateOrderStatus(orderInput: orderStatusInput, orderid: string): Observable<CancelRecord> {
        return this.update(orderInput, orderid).pipe(catchError((error) => of(error)));
    }
    getInvoiceOrderId(orderId: string): Observable<any> {
        return this.getById('invoice/' + orderId).pipe(catchError((error) => of(error)));
    }
    getInvoice(url: string, filename: string): Observable<any> {
        return this.downloadInvoice(url, filename).pipe(catchError((error) => of(error)));
    }
    updateOrderAddress(orderInput: AdminOrderAddressInput, orderid: string): Observable<CancelRecord> {
        return this.update(orderInput, orderid + '/address').pipe(catchError((error) => of(error)));
    }

    exportOrders(body: any): Observable<Blob> {
        return this.downloadFileWithParams('report/orders/export', body).pipe(catchError((error) => of(error)));
    }

    exportStockReports(body: any): Observable<Blob> {
        return this.downloadFileWithParams('report/stock/table/export', body).pipe(catchError((error) => of(error)));
    }

    exportReturnsReport(body: any): Observable<Blob> {
        return this.downloadFileWithParams('report/return/export', body).pipe(catchError((error) => of(error)));
    }
    updateBulkOrderStatus(request: bulkOrderInput): Observable<SubmitResponse> {
        return this.create(request, 'bulk-update-status').pipe(catchError((error) => of(error)));
    }

}